import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="green" viewBox="0 0 12 12">
      <circle cx="6" cy="6" r="6" fill="#0e0"></circle>
    </svg>
  )
}

export default Icon
